import { mergeStyleSets } from "office-ui-fabric-react";

export const classNames = mergeStyleSets({
  exampleRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#a19f9d",
  },
  nameText: {
    fontWeight: "normal",
    marginLeft: "20px",
  },
});

export const teamStyle = () => {
  const _style = {
    marginTop: "1px",
    borderBottom: "1px solid black",
  };
  return _style;
};
